<template>
  <div id="all-posts" class="container subcategories">
    <div v-for="sub in results" :key="sub.id" class="subcategory">
      <div class="header">
        <h3 class="h3">
          {{ sub.category }}
        </h3>
        <nuxt-link v-if="$store.state.layout !== 'mobile'" :to="`${sub.slug}/`">
          Read All
        </nuxt-link>
      </div>
      <div class="row body">
        <ArticleCard
          v-for="(article, i) in sub.latest"
          :key="i"
          :article="article"
          class="col col-4"
          heading="h4"
        />
      </div>
      <nuxt-link v-if="$store.state.layout === 'mobile'" class="read-all" :to="`${sub.slug}/`">
        Read All
      </nuxt-link>
    </div>
  </div>
</template>
<script>
import ArticleCard from './ArticleCard';

export default {
  name: 'CategoryPage',
  components: {
    ArticleCard,
  },
  props: {
    results: { type: Array, required: true },
  },
};

</script>

<style scoped lang="scss">
.subcategories {
  padding-top: var(--spacing-100);
  padding-bottom: var(--spacing-120);

  .subcategory {
    margin-top: var(--spacing-80);

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(0, 12, 31, 0.12);
      padding-bottom: var(--spacing-16);
      margin-bottom: var(--spacing-24);

      .h3 {
        margin: 0;
      }

      a {
        font-weight: 600;
        font-size: 18px;
        letter-spacing: 0.02em;
      }
    }

    &:first-of-type {
      margin-top: 0;
    }

    .read-all {
      margin-top: var(--spacing-36);
      display: block;
      font-weight: 600;
      font-size: 18px;
      line-height: 100%;
    }
  }
}
</style>
